import * as Yup from 'yup';
import { requiredField } from './utils/messages';

export const detailsSolicitationClientValidationSchema = Yup.object().shape({
  valor: Yup.number().required(requiredField).typeError(requiredField),
  horas: Yup.string().required(requiredField).typeError(requiredField),
  lawyer: Yup.number().required(requiredField).typeError(requiredField),
  areaInterna: Yup.string().required(requiredField).typeError(requiredField),
});
